import React, { useState, useEffect, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonEdit, SelectForm } from "../components/common/Buttons";
import ContentValidation from "../components/common/ContentValidation";
import DataPickerInputModal from "../components/common/DataPickerInputModal";
import TableFilterBox from "../components/common/TableFilterBox";
import PaginationComp from "../components/Dashboard/items/Pagination";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import {
  formatDatePlus,
  getDateFormat,
  prettyDateFormat,
} from "../helpers/Utils";
import {
  exportTrRequests,
  getTrRequests,
} from "../redux/Actions/tr_requests_action";
import { handleKeyDown } from "../helpers/FunctionsGlobal";
import TextInputModal from "../components/common/TextInputModal";
import ButtonSecondary from "../components/common/ButtonSecondary";
import RegularOrderChildren from "../components/common/GlobalModals/Orders/RegularOrderChildren";
import {
  IconEye,
  IconTrRequestDispatch,
  IconTrRequestWithdrawal,
} from "../components/Layout/Icons";
import { RoundedBubble } from "../components/common/StyledComponents";
import { getOrder } from "../redux/Actions/orderAction";
import { InputSwitchComponent } from "../components/globals";
import dayjs from "dayjs";
import { Tooltip } from "antd";

const initialFitler = {
  number: "",
  status: undefined,
  created_at: undefined,
  order_id: "",
  order_type: "",
};
function TrRequestScreen({ history, match }) {
  const dispatch = useDispatch();
  const { totals, current, loading, data } = useSelector(
    (state) => state.custom
  );
  const user_id = useSelector((state) => state.auth.user.id);

  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState(initialFitler);
  const [filterString, setFilterString] = useState("");
  useEffect(() => {
    dispatch(getTrRequests(page, filterString));
  }, [filterString, page]);

  useEffect(() => {
    onFilter();
  }, [filters.status, filters.created_at]);

  const onFilter = () => {
    const { number, status, created_at, order_id, order_type } = filters;
    let filtStr = "";

    if (number) filtStr += `&q[number_cont_any]=${number}`;

    if (order_id)
      filtStr += `&q[tr_request_item_order_number_cont_any]=${order_id}`;
    if (order_type) {
      if (order_type === "true") {
        filtStr += `&only_withdrawal=true`;
      } else {
        filtStr += `&only_dispatch=true`;
      }
    }

    if (created_at)
      filtStr += `&q[created_at_gteq_any]=${created_at}&q[created_at_lteq]=${formatDatePlus(
        created_at
      )}`;
    if (status) {
      if (status == "received") {
        filtStr += `&q[call_back_at_null]=0`;
      } else {
        if (status == "exported")
          filtStr += `&q[exported_at_null]=0&q[call_back_at_null]=1`;
        else filtStr += `&q[exported_at_null]=1`;
      }
    }

    setPage(1);
    setFilterString(filtStr);
  };

  return (
    <Container
      location={{
        locationName: "Technorama",
        locationUrl: match.url,
      }}
    >
      <>
        <ContentBlock containerClass={"py-1"}>
          <TableFilterBox
            filter={true}
            onFilter={() => onFilter()}
            clearFilter={() =>
              setFilters({
                ...initialFitler,
                status: filters.status == undefined ? null : undefined,
              })
            }
          >
            <div className="px-1">
              <InputSwitchComponent
                label="Product QTY in order"
                name="product_qty_in_order"
                options={[
                  {
                    label: "Unset",
                    value: "",
                  },
                  {
                    label: "Withdrawal",
                    value: "true",
                  },
                  {
                    label: "Dispatch",
                    value: "false",
                  },
                ]}
                value={filters.order_type || ""}
                onChange={(val) => {
                  console.log(val.target.value);
                  setFilters((prev) => ({
                    ...prev,
                    order_type: val.target.value,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <DataPickerInputModal
                text="Upload date"
                name="created_at"
                classNameLabel="text-sm-label"
                style={{ width: "165px" }}
                value={getDateFormat(filters.created_at)}
                onChange={(_, created_at) =>
                  setFilters((prev) => ({
                    ...prev,
                    created_at,
                  }))
                }
              />
            </div>
            <div className="px-1">
              <TextInputModal
                text="Order no."
                value={filters.order_id}
                name="order_id"
                style={{ width: "165px" }}
                onKeyDown={(e) => handleKeyDown(e, onFilter)}
                onChange={(e) => {
                  const value = e.target.value;
                  setFilters((prev) => ({
                    ...prev,
                    order_id: value,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <SelectForm
                options={[
                  {
                    value: "",
                    label: "All",
                  },
                  {
                    value: "exported",
                    label: "Exported",
                  },
                  {
                    value: "not_exported",
                    label: "Not exported",
                  },
                  {
                    value: "received",
                    label: "Received",
                  },
                ]}
                placeholder="Status"
                value={filters.status}
                style={{ width: "165px" }}
                dropdownMatchSelectWidth={false}
                onChange={(status) => {
                  setFilters((prev) => ({
                    ...prev,
                    status,
                  }));
                }}
              />
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={loading}
              array={data}
              alertId_s="rivileAlert-s"
              alertId_e="rivileAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-hover mt-0">
                  <thead>
                    <tr
                      className="text-black font-semi-bold text-base"
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <th className="pl-3 pt-2">Type & date</th>
                      <th className="pt-2">Order ID’s</th>
                      <th className="pt-2">Status</th>
                      {/* <th className="pt-2">Upload info</th>
                      <th className="pt-2">Export info</th>
                      <th className="pt-2">Technorama info</th> */}
                      <th className="pt-2" colSpan={4}>
                        Info
                      </th>
                      <th className="pt-2 pr-3"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {current == "Technorama" &&
                      data.map((item) => (
                        <TableColumn
                          key={item.id}
                          {...item}
                          history={history}
                          seen={item.seens.includes(user_id)}
                        />
                      ))}
                  </tbody>
                </table>
                <PaginationComp
                  setPagination={setPage}
                  page={1}
                  pageCount={50}
                  totals={totals}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
      </>
    </Container>
  );
}

export default TrRequestScreen;

function TableColumn({
  id,
  number,
  created_at,
  exported_at,
  history,
  created_user_name,
  exported_user_name,
  user_call_back,
  call_back_at,
  tr_request_histories,
  seen,
  orders,
}) {
  const dispatch = useDispatch();

  const areAllPickupsTrue = (orders) => {
    if (!orders || orders.length === 0) return false;
    return !orders.some((order) => !order.pickup);
  };

  const allPickupsTrue = areAllPickupsTrue(orders);

  return (
    <tr className="align-middle tableColumn">
      <td className="align-middle pl-3">
        <div style={{ height: 25 }} className="d-flex align-items-center">
          {orders && orders.length > 0 ? (
            allPickupsTrue ? (
              <Tooltip placement="top" title="Withdrawal">
                <div className="d-flex align-items-center justify-content-center">
                  <IconTrRequestWithdrawal />
                </div>
              </Tooltip>
            ) : (
              <Tooltip placement="top" title="Dispatch">
                <div className="d-flex align-items-center justify-content-center">
                  <IconTrRequestDispatch />
                </div>
              </Tooltip>
            )
          ) : (
            ""
          )}

          <p className="tr-request-date-text">
            {dayjs(created_at).format("YYYY-MM-DD")}
          </p>
        </div>
      </td>
      <td className="align-middle">
        {orders?.length > 0 ? <OrderPreview orders={orders || []} /> : "-"}
      </td>
      <td className="align-middle">
        <div className="d-flex align-items-center">
          <div
            style={{
              border: !seen && call_back_at ? "1px solid #03B0F7" : "none",
              marginRight: 5,
              borderRadius: "50%",
              padding: 2,
            }}
          >
            <div
              style={{
                background:
                  !seen && call_back_at
                    ? "#F29302"
                    : call_back_at
                    ? "#5CB800"
                    : "#DC0032",
                width: !seen && call_back_at ? 8 : 10,
                height: !seen && call_back_at ? 8 : 10,
                borderRadius: "50%",
              }}
            />
          </div>
          {call_back_at
            ? "Received"
            : exported_at
            ? "Exported"
            : "Not exported"}
        </div>
      </td>
      {/* <td className="align-middle">
        {prettyDateFormat(created_at)}
        <br />
        Created by: {created_user_name}
      </td>
      <td className="align-middle">
        {exported_at && (
          <>
            {prettyDateFormat(exported_at)}
            <br />
            Exported by: {exported_user_name || "None"}
          </>
        )}
      </td>
      <td className="align-middle">
        {call_back_at && (
          <>
            {prettyDateFormat(call_back_at)}
            <br />
            Exported from TECHNORAMA by: {user_call_back || "None"}
          </>
        )}
      </td> */}
      <td className="align-middle" colSpan={4}>
        <HistoryPreview tr_request_histories={tr_request_histories || []} />
      </td>
      <td className="align-middle d-flex align-items-center justify-content-end pr-3">
        {!exported_at && (
          <div
            style={{
              width: 125,
            }}
          >
            <ButtonSecondary
              outline={true}
              onClick={() => {
                dispatch(exportTrRequests(id));
              }}
            >
              Export
            </ButtonSecondary>
          </div>
        )}
        <div
          className="ml-2"
          style={{
            width: 35,
            height: 35,
          }}
        >
          <ButtonSecondary
            onClick={() => history.push(`/technorama/tr_request/${id}`)}
          >
            <IconEye />
          </ButtonSecondary>
        </div>
      </td>
    </tr>
  );
}

const HistoryPreview = ({ tr_request_histories }) => {
  const [showAll, setShowAll] = useState(false);
  const total = tr_request_histories.length;
  return (
    <div
      className="bg-white"
      style={{
        border: "1px solid #EBEBEB",
        borderRadius: 4,
      }}
    >
      <div
        className="col-12 d-flex align-items-center justify-content-between py-2 font-medium"
        style={{
          borderBottom: "1px solid #EBEBEB",
        }}
      >
        <div className="d-flex align-items-center">
          <RoundedBubble>{total}</RoundedBubble>
          <div className="text-sm text-black">events</div>
        </div>
        <div
          className="text-sm text-gray-500 text-decoration-underline cursor-pointer"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? "Hide all" : "Show all"}
        </div>
      </div>
      {showAll &&
        tr_request_histories.map((d, idx) => {
          return (
            <div className="text-sm col-12" key={d.id}>
              <div
                className="d-flex align-items-center py-2"
                style={{
                  borderBottom:
                    total == idx + 1 ? "none" : "1px solid rgba(0, 0, 0, 0.08)",
                }}
              >
                <RoundedBubble primary={false}>{idx + 1}</RoundedBubble>
                <div>
                  <b>
                    {d.action || "No status"}: {prettyDateFormat(d.created_at)}
                  </b>
                  <div
                    style={{
                      lineHeight: "17px",
                    }}
                  >
                    {d.info.full_name}; {d.info.email}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

const OrderPreview = ({ orders }) => {
  const dispatch = useDispatch();
  const [showAll, setShowAll] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const total = orders?.length;
  const modalRef = createRef();

  const orderModal = (order_id, id) => {
    const type = order_id.startsWith("FO") ? "FakeOrder" : "Order";
    if (type === "FakeOrder") {
      modalRef.current.openModal("FakeOrderShowModal");
      return;
    }
    setOrderId(id);
    dispatch(getOrder(id));
    modalRef.current.openModal("OrderShowModal");
  };

  const renderOrderNumbers = () =>
    orders?.map((d) => (
      <div
        onClick={() => orderModal(d.number, d.id)}
        className="text-sm pr-1"
        key={d.number}
      >
        <p
          style={{
            margin: 0,
            color: "#03B0F7",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {d.number}
        </p>
      </div>
    ));

  if (total < 5) {
    return (
      <div className="d-flex flex-row flex-wrap">
        {renderOrderNumbers()}
        <div id="modal-roots" />
        <RegularOrderChildren
          ref={modalRef}
          requiredOrderId={orderId}
          modal_type={"TrRequest"}
        />
      </div>
    );
  }

  return (
    <div
      className="bg-white"
      style={{
        border: "1px solid #EBEBEB",
        borderRadius: 4,
        maxWidth: 300,
      }}
    >
      <div
        className="col-12 d-flex align-items-center justify-content-between py-2 font-medium"
        style={{
          borderBottom: "1px solid #EBEBEB",
        }}
      >
        <div className="d-flex align-items-center">
          <RoundedBubble>{total}</RoundedBubble>
          <div className="text-sm text-black">orders</div>
        </div>
        <div
          className="text-sm text-gray-500 text-decoration-underline cursor-pointer"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? "Hide all" : "Show all"}
        </div>
      </div>
      <div style={{ maxWidth: 300 }} className="d-flex flex-row flex-wrap px-3">
        {showAll && renderOrderNumbers()}
      </div>
      <div id="modal-roots" />
      <RegularOrderChildren ref={modalRef} requiredOrderId={orderId} />
    </div>
  );
};
